"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromUTC = fromUTC;
exports.toUTC = toUTC;
const moment_1 = __importDefault(require("moment"));
function fromUTC(utc) {
    return moment_1.default.unix(utc);
}
function toUTC(date) {
    return date.unix();
}
//# sourceMappingURL=parsing.js.map